var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useRef } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
// @ts-ignore
import useVisibility from "react-use-visibility";
import useComponentSize from "@rehooks/component-size";
import i18next from "i18next";
import { Skeleton } from "@material-ui/lab";
import DrawTemplate from "../../SPA/Components/Template/DrawTemplate";
import { getBoxSize } from "../../../utils";
import { createInstance, fillResources, getTemplateTranslation, } from "../../Providers/TemplateInstanceProvider";
import { useAPI } from "../../../lib/common";
import useRoutes, { getLinkComponentAttributes } from "../../hooks/useRoutes";
const useStyles = makeStyles((theme) => ({
    templateList: {
        margin: 0,
        padding: 0,
        display: "grid",
        [theme.breakpoints.up("xs")]: {
            gridTemplateColumns: "repeat(2, 1fr)",
        },
        [theme.breakpoints.up("sm")]: {
            gridTemplateColumns: "repeat(3, 1fr)",
        },
        [theme.breakpoints.up("lg")]: {
            gridTemplateColumns: "repeat(4, 1fr)",
        },
        gridGap: theme.spacing(1),
        listStyle: "none",
        "& > li": {
            position: "relative",
            backgroundColor: 'var(--primaryLightColor)',
            boxShadow: "0px 3px 6px #00000029",
            [theme.breakpoints.down("xs")]: {
            //flexBasis: '50%'
            },
        },
    },
    contentContainer: {
        //display: 'block',
        boxSizing: "border-box",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        textDecoration: "none",
        "&:hover $templatePreviewContainer": {
            transform: "scale(1.02)",
        },
    },
    aspectRatioOuterContainer: {
        width: "100%",
        paddingTop: "calc(1 * 100%)",
        position: "relative",
    },
    aspectRatioInnerContainer: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
    },
    templatePreviewContainer: {
        flexGrow: 1,
        padding: "10px",
        boxSizing: "border-box",
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "transform 0.2s",
        "& .template-inner-container $previewImage": {
            filter: "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.16))",
        },
        "&.no-shadow .template-inner-container, &.no-shadow $previewImage": {
            boxShadow: "none",
        },
    },
    templateContainer: {
        flexGrow: 1,
        padding: "10px",
        boxSizing: "border-box",
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& .template-inner-container": {
            boxShadow: "0px 3px 6px #00000029",
        },
        "&.no-shadow .template-inner-container, &.no-shadow $previewImage": {
            boxShadow: "none",
        },
    },
    photgiftPreviewContainer: {
        backgroundColor: "white",
    },
    skeletonItem: {
        width: "100%",
        paddingTop: "100%",
    },
    templateNameContainer: {
        display: "flex",
        flexGrow: 1,
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        color: theme.palette.primary.main,
        textAlign: "center",
        fontSize: "12px",
    },
    previewImage: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        objectPosition: "center center",
    },
}));
export default ({ category, templates, imageList, displayTemplateName, type, canViewWithOwnPictures, separateFromBackground, }) => {
    const classes = useStyles();
    const routes = useRoutes();
    console.log("Rendering templates num", templates.length, displayTemplateName);
    const previewOwnImages = imageList.length > 0 && canViewWithOwnPictures;
    return (React.createElement("ul", { className: classes.templateList }, templates.map((template) => {
        let path = "products.categories.category.create";
        if (type == "calendars") {
            path = "products.calendars.create";
        }
        const link = getLinkComponentAttributes({
            path,
            variables: {
                type: type,
                category: category,
                productUuid: template.product.uuid,
                templateUuid: template.uuid,
            },
        }, routes);
        return (React.createElement("li", { key: `${template.uuid}-${template.product.uuid}` },
            React.createElement(Link, Object.assign({}, link, { className: classes.contentContainer }),
                React.createElement("div", { className: classes.aspectRatioOuterContainer },
                    React.createElement("div", { className: classes.aspectRatioInnerContainer },
                        previewOwnImages ? (React.createElement(TemplateContainer, { template: template, imageList: imageList, separateFromBackground: separateFromBackground })) : (React.createElement(TemplatePreviewContainer, { template: template, separateFromBackground: separateFromBackground })),
                        displayTemplateName && (React.createElement("div", { className: classes.templateNameContainer }, getTemplateTranslation(template.name, i18next.language))))))));
    })));
};
const Link = (_a) => {
    var { component: Component } = _a, props = __rest(_a, ["component"]);
    return React.createElement(Component, Object.assign({}, props));
};
const TemplatePreviewContainer = ({ template, separateFromBackground, }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: `${classes.templatePreviewContainer} ${separateFromBackground ? "" : "no-shadow"}` },
        React.createElement("img", { className: `${classes.previewImage}`, src: `/templates2/all/${template.preview.large}` })));
};
const TemplateContainer = ({ template, separateFromBackground, imageList, }) => {
    // Use a ref to attach to the element whose visibility you want to keep track of.
    const ref = useRef(null);
    const classes = useStyles();
    // `current` points to the mounted img element.
    const isVisible = useVisibility(ref.current, { partial: true });
    const size = useComponentSize(ref);
    const cs = useMemo(() => {
        if (ref.current) {
            const padding = parseInt(window
                .getComputedStyle(ref.current, null)
                .getPropertyValue("padding-left"));
            const width = size.width - padding * 2;
            const height = size.height - padding * 2;
            const cSize = {
                width: width,
                height: height,
            };
            const info = getBoxSize("fit-in", template, cSize);
            console.log("Template area is", size, info);
            return info;
        }
        return size;
    }, [size]);
    return (React.createElement("div", { ref: ref, className: `${classes.templateContainer} ${separateFromBackground ? "" : "no-shadow"}` },
        React.createElement("div", { style: {
                position: "relative",
                width: cs.width + "px",
                height: cs.height + "px",
            } }, isVisible ? (React.createElement(TemplateInnerContainer, { size: cs, templateListItem: template, imageList: imageList })) : (""))));
};
const TemplateInnerContainer = ({ size, templateListItem, imageList, }) => {
    const [template, loading] = useAPI("/m/api/templates/by-uuid/" +
        templateListItem.uuid +
        "/" +
        templateListItem.version);
    const templateInstance = useMemo(() => {
        if (loading) {
            return null;
        }
        let instance = createInstance(template);
        console.log("Image list is", imageList);
        instance.resources = fillResources(instance.resources, template, imageList);
        console.log("The instance is ", instance);
        return instance;
    }, [template, imageList, loading]);
    if (!templateInstance) {
        return null;
    }
    console.log("Drawing template with container size", size, templateInstance);
    return (React.createElement(DrawTemplate, { containerSize: size, templateInstance: templateInstance }));
};
export const TemplateListItemsSkeleton = () => {
    const classes = useStyles();
    const numProducts = Array.from(Array(10).keys());
    return (React.createElement("ul", { className: classes.templateList }, numProducts.map((i) => {
        return (React.createElement("li", { key: i },
            React.createElement(Skeleton, { variant: "rect", className: classes.skeletonItem })));
    })));
};
